import ApiProvider from 'src/core/ApiProvider';

export default {
  newSubscribe: ({ email }: { email: string }) => {
    return ApiProvider({
      email,
      methodName: 'Module/Subscribe/NewSubscribe',
    });
  },
};
